import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#1f2937'
    }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '8px', color: '#111827' }}>
        Privacy Policy
      </h1>
      <p style={{ color: '#6b7280', marginBottom: '32px' }}>Last Updated: November 5, 2025</p>

      {/* Add your existing privacy policy sections here */}

      <section style={{ marginBottom: '32px', borderTop: '2px solid #e5e7eb', paddingTop: '32px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px', color: '#111827' }}>
          SMS Text Messaging
        </h2>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Information We Collect
        </h3>
        <p>When you consent to receive SMS messages through dealerships using our platform, we collect:</p>
        <ul style={{ marginLeft: '20px', marginTop: '12px' }}>
          <li>Mobile phone number</li>
          <li>First and last name</li>
          <li>Vehicle information (year, make, model, VIN, mileage)</li>
          <li>Message history and responses</li>
          <li>Opt-in/opt-out preferences</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          How We Use Your Information
        </h3>
        <p>We use your mobile number and vehicle information to:</p>
        <ul style={{ marginLeft: '20px', marginTop: '12px' }}>
          <li>Send personalized trade-in offers on behalf of dealerships</li>
          <li>Facilitate conversational AI responses to your inquiries</li>
          <li>Track message delivery and response rates</li>
          <li>Honor opt-out requests immediately</li>
          <li>Improve our service quality</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Third-Party Service Providers
        </h3>
        <p>
          We use Twilio Inc. as our SMS messaging service provider. Your phone number and messages 
          are transmitted through Twilio's infrastructure. Twilio's privacy policy can be found at{' '}
          <a href="https://www.twilio.com/legal/privacy" target="_blank" rel="noopener noreferrer" 
             style={{ color: '#3b82f6' }}>
            https://www.twilio.com/legal/privacy
          </a>.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Data Retention
        </h3>
        <p>
          We retain your SMS consent status and message history for as long as you maintain a 
          relationship with the dealership, or until you opt out. After opt-out, we retain only 
          the minimum information necessary to honor your opt-out preference.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Your Rights
        </h3>
        <p>You have the right to:</p>
        <ul style={{ marginLeft: '20px', marginTop: '12px' }}>
          <li>Opt out of SMS messages at any time by replying STOP</li>
          <li>Request deletion of your personal information</li>
          <li>Access the data we have about you</li>
          <li>Correct inaccurate information</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Security
        </h3>
        <p>
          We use industry-standard security measures to protect your phone number and personal 
          information from unauthorized access, disclosure, or misuse.
        </p>
      </section>

      <section style={{ background: '#f3f4f6', padding: '20px', borderRadius: '8px', marginTop: '40px' }}>
        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151' }}>
          Contact Us
        </h3>
        <p>
          If you have questions about this Privacy Policy or how we handle your data:<br />
          Email: <a href="mailto:david@vincentrix.com" style={{ color: '#3b82f6' }}>david@vincentrix.com</a><br />
          Company: VinCentrix, LLC
        </p>
      </section>

    </div>
  );
};

export default PrivacyPolicy;

